/**
 * Immutable dot-path setter, e.g. setPath(body, 'request.sessionHeader', header).
 * Used by api/client.ts to inject the session into request DTOs whose sessionHeader
 * field is nested rather than top-level.
 */
export function setPath<T extends object>(obj: T, path: string, value: unknown): T {
  const keys = path.split('.');
  const clone: Record<string, unknown> = { ...(obj as Record<string, unknown>) };
  let cursor = clone;

  for (let i = 0; i < keys.length - 1; i++) {
    const key = keys[i];
    const existing = cursor[key];
    const next: Record<string, unknown> =
      existing && typeof existing === 'object' ? { ...(existing as Record<string, unknown>) } : {};
    cursor[key] = next;
    cursor = next;
  }

  cursor[keys[keys.length - 1]] = value;
  return clone as T;
}
